import ic_chevron_down_24 from '../../../../static/icons/ic_chevron_down_24.svg';

export const InfoCardTheme = Object.freeze({
  DEFAULT: '',
  PANDORA_PLUS: 'plus',
  PANDORA_PREMIUM: 'premium',
});

export const InfoCardIcons = Object.freeze({
  CHEVRON_DOWN: ic_chevron_down_24,
});
